/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PlayArrowFillIcon = function PlayArrowFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M6 18.2768V5.72316C6 4.95534 6.82948 4.47397 7.49614 4.85491L18.4806 11.1317C19.1524 11.5156 19.1524 12.4843 18.4806 12.8682L7.49614 19.145C6.82948 19.526 6 19.0446 6 18.2768Z"
  }));
};
export default PlayArrowFillIcon;